import Address from "../../contact/address";
import BusinessPhoneNumber from "../../contact/business-phone-number";
import NamedContact from "../../named-contact";

export default class PatientContact implements NamedContact {
  id: number;
  address: Address;
  emailAddress: string;
  fax: BusinessPhoneNumber;
  createdDatetime: Date;
  firstName: string;
  lastName: string;
  mobile: BusinessPhoneNumber;
  otherRelationship: string;
  phone: BusinessPhoneNumber;
  primaryCaregiver: boolean;
  primaryContact: boolean;
  externalId: number;
  relationship: string;
  type: string;
  prefix: string;
  suffix: string;
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/contacts/patient-contact.ts